<script>
import { AppLayout, PageHeader } from '@/components/layout'
import CustomSeatForm from '@/components/forms/custom-seat-form/index'
import appConfig from '@/app.config'
import { mapGetters } from 'vuex'

export default {
  name: 'milling.form',
  page: {
    title: 'Milling Form',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader,
    CustomSeatForm
  },
  data: () => ({
    quantity: 1,
    specifications: {}
  }),
  computed: {
    ...mapGetters('auth', ['resolveCustomerAccountId'])
  },
  methods: {
    onCustomFormComplete (data) {
      this.showCustomForm = false
      this.specifications = data
      this.addToCart()
    },
    async addToCart () {
      let {
        reference,
        file_id,
        shipping_address_id,
        comments,
        specs = {}
      } = this.specifications

      const customer_account_id = this.resolveCustomerAccountId(this.specifications)

      if (!customer_account_id) {
        this.$root.$bvToast.toast('Please select a customer before adding to cart.', {
          title: 'Customer required',
          solid: true,
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-center'
        })
        return
      }

      let item = await this.$store.dispatch('cart/addToCart', {
        data: {
          ...this.specifications,
          type: 'milling-form',
          product_id: this.productId,
          quantity: this.quantity,
          form_data: { ...specs },
          reference,
          file_id,
          shipping_address_id,
          customer_account_id,
          comments
        }
      })
      this.specifications = {}
      this.$root.$bvToast.toast(`Item added to Cart.`, {
        title: 'Item Added',
        solid: true,
        variant: 'info',
        autoHideDelay: 1000,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })
    }
  }
}
</script>
<template>
  <AppLayout>
    <PageHeader :title="$t('milling.form')" />
    <custom-seat-form v-on:complete="onCustomFormComplete" />
  </AppLayout>
</template>
